export default function Home(){

    return(
        <div className="bg-slate-700 h-full">
            <h1 className="text-white text-2xl p-5">Welcome to my portfolio</h1>
        </div>
    )
}